import { render, staticRenderFns } from "./MonsterQueryContent.vue?vue&type=template&id=40c39b2d"
import script from "./MonsterQueryContent.vue?vue&type=script&lang=js"
export * from "./MonsterQueryContent.vue?vue&type=script&lang=js"
import style0 from "./MonsterQueryContent.vue?vue&type=style&index=0&id=40c39b2d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports